export const formModel = () => ({
    vehicle_id: {
        items: [],
        value: ''
    },
    driver: {
        value: ''
    }
})

export const formRule = () => ({
    vehicle_id: {
        value: [{
            required: true,
            message: '请选择车辆名称'
        }]
    }
})

export const innerFormModal = () => ({
    name: [],
    discount: '',
    amount: '',
    weight: '',
    money: '',
    remark: ''
})

export const innerFormRule = () => ({
    name: [{
        required: true,
        validator: (rule, value, callback) => {
            if (value.length && value.every((s) => Boolean(s))) {
                callback()
            } else {
                callback(new Error('请输入商品名称'))
            }
        },
        message: '请选择商品名称'
    }],
    amount: [{
        validator: (rule, value, callback) => {
            if (value !== '' && !isNaN(value)) {
                callback()
            } else {
                callback(new Error('请输入总数量'))
            }
        },
        message: '请输入总数量'
    }],
    weight: [{
        validator: (rule, value, callback) => {
            if (value !== '' && !isNaN(value)) {
                callback()
            } else {
                callback(new Error('请输入总重量'))
            }
        },
        message: '请输入总重量'
    }],
    money: [{
        validator: (rule, value, callback) => {
            if (value !== '' && !isNaN(value)) {
                callback()
            } else {
                callback(new Error('请输入总价'))
            }
        },
        message: '请输入总价'
    }]
})

export const columns = () => [{
    title: '商品名称',
    dataIndex: 'goodsname',
    key: 'goodsname',
    align: 'center'
},
{
    title: '商品类型',
    dataIndex: 'specification',
    key: 'specification',
    width: 140,
    align: 'center'
},
{
    title: '总数量',
    dataIndex: 'amount',
    key: 'amount',
    align: 'center'
},
{
    title: '总重量',
    dataIndex: 'weight',
    key: 'weight',
    align: 'center'
},
{
    title: '总价',
    dataIndex: 'money',
    key: 'money',
    align: 'center'
},
{
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    align: 'center',
    ellipsis: true
},
{
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
    scopedSlots: {
        customRender: 'c-action'
    }
}]

export const statistic = () => [{
    name: '总数量',
    unit: '瓶',
    value: 0
},
{
    name: '总重量',
    unit: '千克',
    value: 0
},
{
    name: '总价',
    unit: '元',
    value: 0
}]
